import * as nativeStore from './store/useNativeStore'
import * as vuexStore from './store/useVuexStore';
import createApp from './app'
import Vue3Storage from "vue3-storage";
import BootstrapVue3 from 'bootstrap-vue-3';
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";


const _vuexStore = vuexStore._createStore();

const _nativeStore = nativeStore._createStore();

if (window.__INITIAL_NATIVE_STATE__) {
	Object.keys(window.__INITIAL_NATIVE_STATE__).forEach((k) => {
		_nativeStore[k] = window.__INITIAL_NATIVE_STATE__[k];
	});
}

const { app, router, head } = createApp({
	nativeStore: _nativeStore,
	vuexStore: _vuexStore,
});
app.use(Vue3Storage, { namespace: "oright_pro_z_" });
app.use(BootstrapVue3);
app.use(BootstrapIconsPlugin);

(async (r, a, h) => {
	await r.isReady();

	if (window.__INITIAL_STATE__) {
		window.__INITIAL_STATE__.headerStore.loggedIn = _vuexStore.state.headerStore.loggedIn;
		window.__INITIAL_STATE__.headerStore.userStatePromise = _vuexStore.state.headerStore.userStatePromise;
		_vuexStore.replaceState(window.__INITIAL_STATE__);
	}

	delete window.__INITIAL_STATE__
	delete window.__INITIAL_NATIVE_STATE__
	a.mount('#app', true);
})(router, app, head);
